export default __webpack_public_path__ + "static/media/Monger-HUD-Pop-Up (Data Feed).13d79500.jpg";